import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { TruckIcon } from "@heroicons/react/24/outline";
import ShippingInfo from "@/pages/(app)/returns/view/components/return-sidebar/shipping-info";

type TransportProps = {
	returnRequest: ReturnRequestDto;
};

export default function Transport({ returnRequest }: TransportProps) {
	const t = useTranslation();

	return (
		<div>
			<h2 className="text-sm font-medium text-gray-500 inline-flex items-center gap-2">
				<TruckIcon className="size-3" />
				{t("returnDetail.rightBar.transport")}
			</h2>
			{returnRequest.shipping_info.carrier && (
				<ShippingInfo returnRequest={returnRequest} />
			)}
		</div>
	);
}
